/* Pialú · PDP media progress indicator (Hay Harper style)
   Drives a slim track + sliding thumb from the existing <scroll-slider-component>
   WITHOUT forking scroll-slider.js. Mobile only. Deferred load => no LCP cost. */
(function () {
  'use strict';

  function PdpMediaProgress(el) {
    if (el.dataset.pdpProgressInit === '1') return;
    el.dataset.pdpProgressInit = '1';

    this.el = el;
    this.thumb = el.querySelector('.pdp-media-progress__thumb');
    this.id = el.dataset.sliderId;
    this.component = document.querySelector('scroll-slider-component[data-id="' + this.id + '"]');
    this.slider = this.component && this.component.querySelector('.scroll-slider__slider');
    if (!this.slider || !this.thumb) return;

    this.update = this.update.bind(this);
    this.refreshTotal = this.refreshTotal.bind(this);

    // Continuous tracking (the thumb follows the finger as you swipe).
    this.slider.addEventListener('scroll', this.update, { passive: true });
    // Discrete + (re)initialisation hooks exposed by scroll-slider.js.
    document.addEventListener('scroll-slider-' + this.id + ':initialized', this.refreshTotal);
    document.addEventListener('scroll-slider-' + this.id + ':slide-changed', this.update);
    // Variant change can rebuild/reflow the media — recompute defensively.
    document.addEventListener('variant:change', this.refreshTotal);
    window.addEventListener('resize', this.refreshTotal, { passive: true });

    this.refreshTotal();
  }

  PdpMediaProgress.prototype.countSlides = function () {
    // Prefer the engine's own count; fall back to visible children.
    var n = parseInt(this.slider.dataset.slideCount, 10);
    if (n && n > 0) return n;
    var kids = this.slider.children, visible = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].clientWidth > 0) visible++;
    }
    return visible || kids.length || 1;
  };

  PdpMediaProgress.prototype.refreshTotal = function () {
    this.total = this.countSlides();
    this.el.style.setProperty('--pdp-total', this.total);
    if (this.total <= 1) {
      this.el.style.display = 'none';
    } else {
      this.el.style.display = '';
    }
    this.update();
  };

  PdpMediaProgress.prototype.update = function () {
    if (!this.total || this.total <= 1) return;
    var max = this.slider.scrollWidth - this.slider.clientWidth;
    var p = max > 0 ? this.slider.scrollLeft / max : 0;
    if (p < 0) p = 0; else if (p > 1) p = 1;
    this.el.style.setProperty('--pdp-pos', p * (this.total - 1));
  };

  function init(root) {
    (root || document).querySelectorAll('[data-pdp-media-progress]').forEach(function (el) {
      new PdpMediaProgress(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Theme editor: re-init when the product section is reloaded.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
